import { useTranslation } from 'react-i18next';
import parse from 'html-react-parser';
import { useModal } from '@/hooks';
import { toast } from 'react-toastify';
import { Button, RequestMonitoringModal, SvgIcon } from '@/components';
import { COMMON_CONTAINER_ID } from '@/config';
import { HubspotProvider } from '@aaronhayes/react-use-hubspot-form';

import styles from './ThisIsDemoData.module.sass';

const ThisIsDemoData = () => {
  const { t } = useTranslation();

  const {
    isOpen: isShowContactModal,
    onOpenModal: handleContactModal,
    onCloseModal: handleCloseContactModal,
  } = useModal();

  const onSuccessfulSubmit = () => {
    handleCloseContactModal();

    toast.success(t('translation.send_plan_rq_msg'), {
      containerId: COMMON_CONTAINER_ID,
    });
  };

  return (
    <HubspotProvider>
      <div className={styles.info}>
        <div className={styles.content}>
          <div className={styles.title}>
            {parse(t('translation.this_is_demo_data'))}
          </div>
          <div className={styles.description}>
            {t('translation.this_is_demo_data_description')}
          </div>
        </div>

        <div className={styles.actions}>
          <Button
            size="m"
            type="primary-black"
            corner="rect"
            onClick={handleContactModal}
          >
            <span>{t('translation.contact_us')}</span>
            <SvgIcon name="arrow-right" />
          </Button>
        </div>

        <SvgIcon name="aml" className={styles.dec} />
      </div>

      {isShowContactModal && (
        <RequestMonitoringModal
          isOpen={isShowContactModal}
          onClose={handleCloseContactModal}
          onSuccessfulSubmit={onSuccessfulSubmit}
        />
      )}
    </HubspotProvider>
  );
};

export default ThisIsDemoData;
